import ColumnMapper, { ColumnsMapProps, OptionInfo, TargetField } from './ColumnMapper';

export default ColumnMapper;
export type { ColumnsMapProps, OptionInfo, TargetField };
